import { Dispatch, SetStateAction } from 'react';

import { updateSnapStatusSuccessAction } from 'containers/Snaps/Snap/store';

import { removeItemFromArrayWithState } from 'utils';

import {
  DeleteMatchResponse,
  OfferLineItemMatch,
  SnapMatchesResponse,
} from 'codegen';
import {
  IDataResponse,
  TRequestCallback,
} from 'types';

import { getFormattedMatchedOfferItem } from './mappers';

export const handleSuccessGetMatchesLineItems = (
  setMatchesData: Dispatch<OfferLineItemMatch[] | undefined>,
) => (
  { data }: IDataResponse<SnapMatchesResponse>,
) => {
  const { matchedItems } = data;

  setMatchesData(matchedItems.map(getFormattedMatchedOfferItem));
};

export const handleDeleteMatchesLineItem = (
  onDeleteTableData: TRequestCallback,
  snapId?: string,
) => (
  id: number,
) => {
  onDeleteTableData({ callbackURL: `/snaps/old/${snapId}/matches/${id}` });
};

export const handleSuccessDeleteMatchesLineItem = (
  setMatchesData: Dispatch<SetStateAction<OfferLineItemMatch[] | undefined>>,
) => (
  { data }: IDataResponse<DeleteMatchResponse>,
) => {
  removeItemFromArrayWithState({ value: data.id, setState: setMatchesData });
  updateSnapStatusSuccessAction(data.state);
};
